import { createAction } from 'redux-actions';

export const requestGetAgentTeamDetailAction = createAction('REQUEST/GET_AGENT_TEAM_DETAIL');
export const reassignShareClientsAction = createAction('REQUEST/REASSIGN_SHARE_CLIENTS');

export const getAgentDocumentsAction = createAction('REQUEST/AGENT_DOCUMENTS');

export const deleteAgentDocumentAction = createAction('REQUEST/DELETE_AGENT_DOCUMENT');
